"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MANUAL_RUN_PAGES_MAX = exports.MANUAL_RUN_ROWS_PAGE = exports.MANUAL_RUN_PAGE_BODY_BYTES = exports.MANUAL_RUN_ROW_ID_MAX_CHARS = exports.MANUAL_RUN_ROWS_MAX = void 0;
exports.manualRunPages = manualRunPages;
const database_identity_1 = require("@streamlain/database-identity");
/**
 * Most rows one manual run may choose: every row a table can hold. The rows
 * of one request are never cut below that.
 */
exports.MANUAL_RUN_ROWS_MAX = database_identity_1.DATABASE_LARGE_DATA_POLICY.database.systemRowHardLimit;
/** Longest row id a manual run names. */
exports.MANUAL_RUN_ROW_ID_MAX_CHARS = 256;
/**
 * JSON body limit of the manual run route (BODY_LIMITS.default of the
 * server, 1 MB).
 */
exports.MANUAL_RUN_PAGE_BODY_BYTES = 1024 * 1024;
/** Room of a page body besides its row ids (docId, request id, page). */
const MANUAL_RUN_PAGE_ENVELOPE_BYTES = 4 * 1024;
/**
 * Most rows one page of a manual run request names: as many of the longest
 * ids (quotes and comma each) as fit the body limit. A page size, not a
 * limit of the run: a larger choice goes in several pages.
 */
exports.MANUAL_RUN_ROWS_PAGE = Math.floor((exports.MANUAL_RUN_PAGE_BODY_BYTES - MANUAL_RUN_PAGE_ENVELOPE_BYTES) /
    (exports.MANUAL_RUN_ROW_ID_MAX_CHARS + 3));
/** Most pages one manual run request has. */
exports.MANUAL_RUN_PAGES_MAX = Math.ceil(exports.MANUAL_RUN_ROWS_MAX / exports.MANUAL_RUN_ROWS_PAGE);
/** The chosen rows in the pages one manual run request sends, in order. */
function manualRunPages(rowIds) {
    const pages = [];
    for (let start = 0; start < rowIds.length; start += exports.MANUAL_RUN_ROWS_PAGE) {
        pages.push(rowIds.slice(start, start + exports.MANUAL_RUN_ROWS_PAGE));
    }
    return pages;
}
//# sourceMappingURL=manual-run.js.map